export enum UpgradeErrorCodes {
  CARD_USER_NOT_ENOUGH_FUNDS = 'CARD_USER_NOT_ENOUGH_FUNDS',
}
